import { render, staticRenderFns } from "./TabSlide.vue?vue&type=template&id=1677ba59&scoped=true"
import script from "./TabSlide.vue?vue&type=script&lang=js"
export * from "./TabSlide.vue?vue&type=script&lang=js"
import style0 from "./TabSlide.vue?vue&type=style&index=0&id=1677ba59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677ba59",
  null
  
)

export default component.exports